query hoppermationOrganization($companyId: ID!) {
  organization: hoppermationOrganization(companyId: $companyId) {
    id
    companyId
    status
  }
}
